/* eslint-disable no-nested-ternary */
// eslint-disable-next-line import/no-unresolved
import * as CSS from "csstype";
import React from "react";
import { Route, RouteComponentProps } from "react-router";
import { ResponsiveValue, TLengthStyledSystem } from "styled-system";
import { Box } from "../Box";
import { BreadcrumbItem } from "../BreadcrumbItem";
import { Flex } from "../Flex";

interface BreadCrumbConfig {
  [key: string]: string;
}

// Extending props to include path for match.params.path as this is not defined in RouteComponentProps.
interface RouteParams {
  path: string;
}
interface CrumbProps extends RouteComponentProps<RouteParams> {}

interface Props {
  config?: BreadCrumbConfig;
  fontSize?: ResponsiveValue<CSS.Property.FontSize<TLengthStyledSystem>>;
}

export const Crumb: React.FC<Props & CrumbProps> = ({ location, match, config }) => {
  // This filters the match.url path to not depend on personal/developers/business and only matches
  // the end url parameters.
  const matchUrl = match.url.replace(/(\/personal|\/developers|\/business)/g, "");
  return (
    <>
      {location && location.pathname.match(/\//g)!.length !== 1 ? (
        <>
          <BreadcrumbItem data-testid="BreadCrumbItem" active={match.isExact} color={match.isExact ? "primary" : "accent"} to={match.url}>
            {config && config[matchUrl] === undefined
              ? config[match.params.path] === undefined
                ? match.params.path.replace(/-/g, " ")
                : config[match.params.path]
              : config && config[matchUrl]}
          </BreadcrumbItem>
          {!match.isExact && <Box px={["2px", 2]}>/</Box>}
          <Route path={`${match.url}/:path`} render={props => <Crumb {...props} config={config} />} />
        </>
      ) : null}
    </>
  );
};

export const RouterBreadcrumb: React.FC<Props> = ({ config, fontSize }) => {
  return (
    <Flex
      fontSize={fontSize}
      data-testid="BreadCrumbContainer"
      pt={["24px", "24px", "48px", "48px"]}
      pb={["16px", "16px", "48px", "48px"]}
      flexWrap="wrap"
    >
      <Route path="/:path" render={props => <Crumb {...props} config={config} />} />
    </Flex>
  );
};
RouterBreadcrumb.defaultProps = {
  fontSize: 1,
};
